module.exports = __webpack_public_path__ + "static/media/medichands.7ebf7de1.png";